<template>
  <div class="flex items-center h-100" :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
    <div>
    <link-icon
      v-b-tooltip.hover.html="link_icon"
      size="1.3x"
      class="hover:text-primary cursor-pointer"
      @click="$router.push({ name: 'admin-vendors-smsc-bind', params: { id: params.data.vendor_uuid } })"
    />
    </div>
    <phone-icon
      v-b-tooltip.hover.html="phone_icon"
      size="1.3x"
      class="ml-3 hover:text-primary cursor-pointer"
      @click="$router.push({ name: 'admin-vendors-did', params: { id: params.data.vendor_uuid } })"
    />
    <trending-up-icon
      v-b-tooltip.hover.html="trending_up_icon"
      size="1.3x"
      class="ml-3 hover:text-primary cursor-pointer"
      @click="$router.push({ name: 'admin-vendors-rate-deck', params: { id: params.data.vendor_uuid } })"
    />
    <edit-icon
      v-b-tooltip.hover.html="edit_icon"
      size="1.3x"
      class="ml-3 hover:text-primary cursor-pointer"
      @click="$router.push({ name: 'admin-vendors-edit', params: { id: params.data.vendor_uuid } })"
    />
    <trash-2-icon
      v-b-tooltip.hover.html="delete_icon"
      size="1.3x"
      class="ml-3 hover:text-primary cursor-pointer"
      @click="ConfirmDelete"
    />
  </div>
</template>

<script>
import { LinkIcon, PhoneIcon, TrendingUpIcon, EditIcon, Trash2Icon } from 'vue-feather-icons'

export default {
  data(){
    return{
      link_icon: { title: 'SMS <em>Bind</em>' },
      phone_icon: { title: 'DID' },
      trending_up_icon: { title: 'Rate <em>deck</em>' },
      edit_icon: { title: 'Edit' },
      delete_icon: { title: 'Delete' },
    }
  },
  name: 'CellRendererActions',
  components: {
    LinkIcon,
    PhoneIcon,
    TrendingUpIcon,
    EditIcon,
    Trash2Icon
  },
  methods: {
    tipMethod() {
        // Note this is called each time the tooltip is first opened.
        return '<strong>' + new Date() + '</strong>'
      },
    ConfirmDelete () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Are you sure?',
        text: 'You will not be able to recover this Vendor!',
        accept: this.Delete,
        acceptText: 'Delete'
      })
    },
    Delete () {
      this.$store.dispatch("vendor/Delete", this.params.data.vendor_uuid)
      .then(() => {
        this.params.data.refreshData()
        this.ShowSuccessMessage({
          title: 'Vendor Deleted',
          text: 'The selected Vendor was successfully deleted'
        })
      })
      .catch(err => this.ShowErrorMessage({ title: 'Error', text: err }))
    },

    // Notify
    ShowSuccessMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-check',
        color: 'success',
        title,
        text
      })
    },
    ShowErrorMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger',
        title,
        text
      })
    }
  }
}
</script>
